import convertByOffset from '../convert-by-offset';
import convertByTimezone from '../convert-by-timezone';
import { DEFAULT_TIMEZONES } from '../contants';
var convertDate = function (utcISODate, timezone) {
    if (typeof timezone === 'number' && timezone !== 0) {
        return convertByOffset(utcISODate, timezone);
    }
    else if (typeof timezone === 'string' &&
        !DEFAULT_TIMEZONES.includes(timezone)) {
        return convertByTimezone(utcISODate, timezone);
    }
    return utcISODate;
};
export default convertDate;
